<template>
  <div class="p-2 text-center paket-wrapper text-white">
    <p class="mb-2 text-capitalize headline font-weight-bold">paket Anda</p>
    <p
      class="mb-2 smaller letter-spacing--03"
      v-if="subscribe.punya_paket && subscribe.sisa_kouta != 0"
    >
      ({{ subscribe.sisa_hari }} hari tersisa hingga
      {{ subscribe.habis_berlaku }})
    </p>
    <div v-if="isNewPackage && subscribe.sisa_hari <= 30 && subscribe.sisa_kouta >= 10" class="paket-warning px-2 pt-3 pb-3 pt-1 bg-white">
      Masa berlaku paket Anda akan berakhir, silakan klik tombol di bawah ini untuk membeli masa berlaku
      <br>
      <a target="_blank" href="https://api.whatsapp.com/send/?phone=628111137982&text=Hai Izidok, saya ingin menambah masa berlaku. Mohon info terkait harga paket perpanjangan masa berlaku." class="btn btn-primary">Beli Masa Berlaku</a>
    </div>
    <div
      class="px-2 pb-3 pt-1 bg-white text-black paket-inner h-min-inner"
    >
      <b-row class="my-4" v-if="!subscribe.punya_paket || subscribe.sisa_kouta == 0">
        <b-col class="col-12" v-if="!subscribe.punya_paket">
          <h4 style="color: red;" class="font-weight-bold">Tidak Ada Paket Aktif</h4>
          <p>untuk info berlangganan silakan <br> klik lebih lanjut</p>
        </b-col>
        <b-col class="col-12" v-else-if="subscribe.sisa_kouta == 0">
          <h4 style="color: red;" class="font-weight-bold">Paket Anda Habis</h4>
          <p>untuk info berlangganan silakan <br> klik lebih lanjut</p>
        </b-col>
      </b-row>
      <b-row class="my-4" v-else>
        <b-col class="col-6 text-left pr-0">
          <p style="color: #58a7e2;" class="paket-label font-weight-bold mb-2">Jenis Paket</p>
          <p class="paket-label font-weight-bold">{{ subscribe.nama_paket || '-' }}</p>
        </b-col>
        <b-col class="col-6 text-right pl-0">
          <p style="color: #58a7e2;" class="paket-label font-weight-bold mb-2">Sisa Visit pasien</p>
          <p class="paket-label font-weight-bold">
            <template v-if="subscribe.punya_paket">
              <template v-if="subscribe.limit_paket == 'Unlimited'">
                <font-awesome-layers class="fa-md mr-4 btn-actions">
                  <font-awesome-icon icon="infinity" />
                </font-awesome-layers>
              </template>
              <template v-else>
                {{ subscribe.sisa_kouta }}
              </template>
            </template>
            <template v-else>-</template>
          </p>
        </b-col>
      </b-row>
      <b-row class="my-4">
        <b-col class="col-12 mb-3">
          <hr class="m-2" style="border-top: 2px solid #c0c4cc;">
        </b-col>
        <b-col class="col-6 text-left pr-0">
          <p style="color: #58a7e2;" class="paket-label font-weight-bold mb-2">Jenis Add On</p>
          <p class="paket-label font-weight-bold mb-2">WhatsApp</p>
          <p class="paket-label font-weight-bold">SMS</p>
        </b-col>
        <b-col class="col-6 text-right pl-0">
          <p style="color: #58a7e2;" class="paket-label font-weight-bold mb-2">Sisa Add On</p>
          <p class="paket-label font-weight-bold mb-2">{{ addonWA.sisa || '-' }}</p>
          <p class="paket-label font-weight-bold">{{ addonSMS.sisa || '-' }}</p>
        </b-col>
      </b-row>
      <template>
        <template v-if="this.$store.state.user.roles[0].name === 'dokter_praktek' ">
          <b-button class="text-capitalize" variant="primary" :to="{ name: 'subskripsi' }">lebih lanjut</b-button>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
  import startCase from "lodash/startCase";
  import {
    faArrowRight,
    faArrowUp,
    faCheck,
    faCheckCircle,
    faHome,
    faInfinity,
    faSearch,
    faUser
  } from "@fortawesome/free-solid-svg-icons";
  import {
    FontAwesomeLayers
  } from "@fortawesome/vue-fontawesome";
  import {
    library
  } from "@fortawesome/fontawesome-svg-core";
  library.add(
    faInfinity
  );
  import axios from "axios";

  export default {
    data() {
      return {
        addonWA: null,
        addonSMS: null,
        isNewPackage: false
      };
    },
    components: {
      FontAwesomeLayers,
    },
    props: ["habis_berlaku", "paket", "sisa_hari", "sisa_kouta", "nama_paket", "limit_paket", "subscribe"],
    mounted() {
      this.fetchUser();
    },
    methods: {
      async fetchUser() {
        const res = await axios.get(`${this.url_api}/user/${this.$store.state.user.id}`);
        const { status, addons, paket } = res.data;
        if (status) {
          this.addonWA = addons.filter(t => t.tipe === 'whatsapp')[0] || null;
          this.addonSMS = addons.filter(t => t.tipe === 'sms')[0] || null;
          this.isNewPackage = paket.is_new;
        };
      },
    }
  };
</script>

<style lang="scss" scoped>
  .paket-wrapper {
    background-color: #789dc3;
    border-radius: 10px;

    .smaller {
      font-size: 75%;
    }

    .letter-spacing {
      &--03 {
        letter-spacing: -0.3px;
      }
    }

    .headline {
      font-size: 1.6rem;
      color: #e2ecf6;
      letter-spacing: -0.2px;
    }

    .paket-inner {
      border-radius: 8px;
      color: #4a7fa4;

      .tipe-paket {
        color: #58a7e2;
        font-size: 1.7rem;
      }

      .highlight-text {
        font-size: 5rem;
        line-height: 5.4rem;

        &.--with-spacing {
          letter-spacing: 12px;
          margin-left: calc(50vh - 100%);
        }
      }

      .text-red {
        color: red;
      }

      button {
        background-color: #347b8b;
        color: #fff;
        border: none;
        border-radius: 12px;
      }
    }

    .paket-warning {
      margin-bottom: 10px;
      border-radius: 8px;
      color: #4a7fa4;
    }
  }
  
</style>